import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { connect } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from "../Buttons/ButtonBase";
import { closeModalFree } from "../../store/actions/ModalFree";
import * as ROUTES from '../../routes';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: "100%",
    height: "auto",
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none'
    }
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'
  }
});

function ModalFree(props) {
  let { openModalFree, closeModalFree, role } = props;

  useEffect(() => {
  }, [openModalFree]);

  const handleClose = () => {     
    closeModalFree(false , '', '')
  }

  const classes = useStyles()

  return (
    <Dialog
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      disableEscapeKeyDown
      open={openModalFree.open}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openModalFree.open}>
        <div className={classes.paper}>
          <div onClick={handleClose} className="contentCloseImg">
            <img src="/img/cardpassword/tache.svg" alt="" />
          </div>
            <div className="mainContentTitle">
                <p className="titleModalFree">¡Mejora tu plan!</p>
            </div>
            <div className="contentDataModalFree">
                <p className="textDataModalFree">Con un Plan <span className="textPremiumModalFree">PREMIUM</span> o <span className="textPremiumPlusModalFree">PREMIUM PLUS</span> puedes agregar la información completa a tu perfil.Mejora tu plan y genera contacto con clientes potenciales
                </p>
            </div>
            <div className="contentButtonModalFree">
            <ButtonBase
              onClick={handleClose}
              variant="primary"
              direction={ROUTES.MEMBERSHIPS_LAWYERS}
            >
              Quiero ser PREMIUM
            </ButtonBase>
            </div>
        </div>
      </Fade>
    </Dialog>
  )

}

const mapDispatchToProps = dispatch => ({
  closeModalFree: (open, typeMembership, role) => dispatch(closeModalFree(open, typeMembership, role))
})

const mapStateToProps = state => ({
  openModalFree: state.ModalFreeReducer.openModalFree,
  role: state.authClient.role
});


export default connect(mapStateToProps, mapDispatchToProps)(ModalFree);